// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// THIS FILE WAS AUTOGENERATED
/**
 * Stack frame information.
 */
var StackFrame = /** @class */ (function () {
    function StackFrame() {
    }
    return StackFrame;
}());
export { StackFrame };
//# sourceMappingURL=StackFrame.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-common/dist-esm/Interfaces/Contracts/Generated/StackFrame.js
// module id = 513
// module chunks = 1